import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { Tabs, TabList, TabPanel, Tab } from "react-tabs";
import { ToastContainer, toast } from "react-toastify";
import CountUp from "react-countup";
import { connect } from "react-redux";
import { DollarSign } from "react-feather";
import {
  getAllTransactionRedux,
  getAllTransactionsAllTimeRedux,
  uploadTransactionRedux,
  updateSingleProductRedux,
  adjustProductStockRedux,
} from "../../../actions";
import { Link } from "react-router-dom";

import AllTransactions from "./allTransactions.js";
import { getSingleProduct, getAllTransactionsAllTime } from "../../../firebase/firebase.utils.js";
import { notifyWarning } from "../../../utils/notify";
class SellsReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sourcingObj: null,
      filterCountry: "",
      selectedMonth: "",
      agentPaid: 0,
      product: null,
      variationId: "",
      isAllTime: true,
      availableMonths: [],
    };
  }

  componentDidMount = async () => {
    const { id } = this.props.match.params;

    const [product, allTx] = await Promise.all([
      getSingleProduct(id),
      getAllTransactionsAllTime(id),
    ]);

    this.props.getAllTransactionsAllTimeRedux(id);

    // Build unique months that have at least one transaction, newest first
    const monthOrder = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December",
    ];
    const uniqueMonths = [...new Set((allTx || []).map((t) => t.month).filter(Boolean))];
    uniqueMonths.sort((a, b) => {
      const [mA, yA] = a.split(",");
      const [mB, yB] = b.split(",");
      if (yB !== yA) return parseInt(yB) - parseInt(yA);
      return monthOrder.indexOf(mB) - monthOrder.indexOf(mA);
    });

    this.setState({
      selectedMonth: "All Time",
      product,
      availableMonths: uniqueMonths,
      variationId:
        product.displayedVariations && product.displayedVariations.length > 0
          ? product.displayedVariations[0].id
          : "",
    });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  getMonthName = () => {
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const d = new Date();
    return `${monthNames[d.getMonth()]},${d.getFullYear()}`;
  };

  getMonthsBetween = (startMonth, endMonth) => {
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    let result = [];
    // Parse the start and end months
    const startDate = new Date(startMonth);
    const endDate = new Date(endMonth);

    // Generate the array of months in descending order
    let currentDate = endDate;
    while (currentDate >= startDate) {
      const monthName = months[currentDate.getMonth()];
      const year = currentDate.getFullYear();
      result.push(`${monthName},${year}`);
      // Move to the previous month
      currentDate.setMonth(currentDate.getMonth() - 1);
    }

    return result;
  };

  handleSubmit = async () => {
    let date = new Date();
    if (this.state.quantity > 0) {
      if (
        this.state.product.displayedVariations &&
        this.state.product.displayedVariations.length > 0
      ) {
        if (
          this.state.product.displayedVariations.find(
            (variation) => variation.id == this.state.variationId
          ).inventory &&
          this.state.product.displayedVariations.find(
            (variation) => variation.id == this.state.variationId
          ).inventory > 0
        ) {
          // Atomic −qty; remainingStock is the stock right after it.
          const reduced = await this.props.adjustProductStockRedux({
            productId: this.state.product.id,
            variationId: this.state.variationId,
            delta: -parseInt(this.state.quantity),
          });
          this.props.uploadTransactionRedux({
            id: date.getTime().toString() + "1",
            fundType: "Selling",
            subCategory: this.state.subCategory,
            orderStatus: "Reduced",
            month: this.getMonthName(),
            date: date.toLocaleDateString("en-GB"),
            totalBill: this.state.totalBill,
            perUnitPrice: this.state.perUnitPrice,
            expenseBy: this.props.currentAdmin
              ? this.props.currentAdmin.name
              : "",
            note: this.state.note,
            unEditable: true,
            productId: this.state.product.id,
            sellStock: this.state.quantity,
            remainingStock: reduced ? reduced.remaining : null,
            productName: this.state.product.name,
            productImage: this.state.product.pictures[0],
            variationId: this.state.variationId,
          });

          toast.success("Item quantity reduced");
          let product = await getSingleProduct(this.state.product.id);
          this.setState({
            subCategory: "",
            note: "",
            totalBill: 0,
            perUnitPrice: 0,
            quantity: 0,
            product: product,
          });
        } else {
          toast.error("Item quantity is already 0.");
        }
      } else {
        if (this.state.product.inventory > 0) {
          const reduced = await this.props.adjustProductStockRedux({
            productId: this.state.product.id,
            delta: -parseInt(this.state.quantity),
          });
          this.props.uploadTransactionRedux({
            id: date.getTime().toString() + "1",
            fundType: "Selling",
            subCategory: this.state.subCategory,
            orderStatus: "Reduced",
            month: this.getMonthName(),
            date: date.toLocaleDateString("en-GB"),
            totalBill: this.state.totalBill,
            perUnitPrice: this.state.perUnitPrice,
            expenseBy: this.props.currentAdmin
              ? this.props.currentAdmin.name
              : "",
            unEditable: true,
            productId: this.state.product.id,
            sellStock: this.state.quantity,
            remainingStock: reduced ? reduced.remaining : null,
            productName: this.state.product.name,
            productImage: this.state.product.pictures[0],
          });
          toast.success("Item quantity reduced");
          let product = await getSingleProduct(this.state.product.id);
          this.setState({
            subCategory: "",
            note: "",
            totalBill: 0,
            perUnitPrice: 0,
            quantity: 0,
            product: product,
          });
        } else {
          toast.error("Item quantity is already 0.");
        }
      }
    } else {
      notifyWarning("sold or reduced quantity must be greater than 0.");
    }
  };

  render() {
    const { sourcingObj } = this.state;
    const { sourcings, currentAdmin, transactions } = this.props;
    let productName = "";
    if (transactions && transactions.length > 0) {
      productName = transactions[0].productName;
    }
    let productImage = "";
    if (transactions && transactions.length > 0) {
      productImage = transactions[0].productImage;
    }
    let date = new Date();
    const monthsArray = this.state.availableMonths;

    const idToTs = (id) => parseInt(String(id || "0").substring(0, 13));
    let sortedTransfers = [...transactions].sort((a, b) => idToTs(b.id) - idToTs(a.id));
    if (
      this.state.product &&
      this.state.product.displayedVariations &&
      this.state.product.displayedVariations.length > 0
    ) {
      sortedTransfers = sortedTransfers.filter(
        (transfer) => transfer.variationId == this.state.variationId
      );
    }
    let stock = 0;
    let stockQuantity = 0;
    let sell = 0;
    let sellQuantity = 0;
    if (sortedTransfers && sortedTransfers.length > 0) {
      let notCancelled = sortedTransfers.filter(
        (transfer) => transfer.orderStatus !== "Cancelled"
      );
      notCancelled.map((transfer) => {
        if (transfer.fundType == "Selling") {
          sell += parseInt(transfer.totalBill);
          sellQuantity += parseInt(transfer.sellStock);
        } else {
          stock += parseInt(transfer.totalCost);
          stockQuantity += parseInt(transfer.productStock);
        }
      });
    }
    return (
      <Fragment>
        <Breadcrumb
          title={this.state.product?.name || productName || "Sells Report"}
          parent="All Products"
        />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid">
          <div
            data-toggle="modal"
            data-target="#personalInfoModal"
            style={{
              marginTop: 20,
              marginLeft: 10,
              color: "white",
              background: "darkorange",
              borderRadius: 5,
              padding: 10,
              display: "inline-block",
              cursor: "pointer",
            }}
          >
            Manage stock
          </div>
          {/* Summary cards */}
          <div style={{ display: "flex", gap: 12, marginTop: 20, marginBottom: 20, flexWrap: "wrap" }}>
            {[
              {
                label: `${this.state.selectedMonth} Stock`,
                qty: `${stockQuantity} pc`,
                value: stock,
                unit: "Tk",
                accent: "rgb(251, 148, 4)",
                icon: "📦",
              },
              {
                label: `${this.state.selectedMonth} Sell`,
                qty: `${sellQuantity} pc`,
                value: sell,
                unit: "Tk",
                accent: "rgb(251, 148, 4)",
                icon: "💰",
              },
              {
                label: "Available Stock",
                qty: null,
                value:
                  sortedTransfers && sortedTransfers.length > 0
                    ? sortedTransfers[0].remainingStock
                    : 0,
                unit: "pc",
                accent: "rgb(251, 148, 4)",
                icon: "🏷️",
              },
            ].map((card, i) => (
              <div
                key={i}
                style={{
                  background: "#fff",
                  borderRadius: 14,
                  padding: "16px 22px",
                  boxShadow: "0 2px 12px rgba(0,0,0,0.07)",
                  borderTop: `3px solid ${card.accent}`,
                  minWidth: 180,
                  flex: "0 0 auto",
                }}
              >
                <div style={{ fontSize: 11, fontWeight: 600, color: "#a0abc0", textTransform: "uppercase", letterSpacing: 0.8, marginBottom: 6 }}>
                  {card.label}
                </div>
                <div style={{ display: "flex", alignItems: "baseline", gap: 5 }}>
                  <span style={{ fontSize: 24, fontWeight: 800, color: "#1a1f36", lineHeight: 1 }}>
                    <CountUp end={card.value} />
                  </span>
                  <span style={{ fontSize: 13, fontWeight: 600, color: "#6b7280" }}>{card.unit}</span>
                </div>
                {card.qty && (
                  <div style={{ fontSize: 12, color: "rgb(251, 148, 4)", fontWeight: 600, marginTop: 4 }}>
                    {card.qty}
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Transactions table */}
          <div className="row">
            <AllTransactions
              props={this.props}
              productId={this.props.match.params.id}
              month={this.state.selectedMonth}
              productImage={
                this.state.product && this.state.product.pictures[0]
              }
              productName={this.state.product && this.state.product.name}
              monthsArray={monthsArray}
              setSelectedMonth={(month) => {
                if (month === "all") {
                  this.setState({ selectedMonth: "All Time", isAllTime: true });
                  this.props.getAllTransactionsAllTimeRedux(
                    this.props.match.params.id
                  );
                } else {
                  this.setState({ selectedMonth: month, isAllTime: false });
                  this.props.getAllTransactionRedux(
                    this.props.match.params.id,
                    month
                  );
                }
              }}
              setVariationId={(id) => {
                this.setState({ variationId: id });
              }}
              variationId={this.state.variationId}
              product={this.state.product}
              sortedTransfers={sortedTransfers}
              isAllTime={this.state.isAllTime}
            />
          </div>
        </div>
        <ToastContainer />
        <div
          className="modal fade"
          id="personalInfoModal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ margin: "auto" }}
          >
            <div
              className="modal-content"
              style={{ top: 10, width: "95%", margin: "auto" }}
            >
              <div
                className="modal-header"
                style={{
                  backgroundColor: "rgb(251, 148, 4)",
                  paddingTop: 20,
                  paddingBottom: 20,
                }}
              >
                <div
                  className="modal-title"
                  style={{
                    fontWeight: "bold",
                    fontSize: 17,
                    color: "white",
                  }}
                  id="exampleModalLabel"
                >
                  Reduce stock quantity
                </div>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  id="personal-info-close"
                >
                  <span aria-hidden="true" style={{ color: "white" }}>
                    &times;
                  </span>
                </button>
              </div>
              <div className="modal-body">
                <div style={{ padding: "10px 15px" }}>
                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Choose variation
                    </label>
                    <select
                      title="Please choose a package"
                      required
                      name="variationId"
                      className="custom-select"
                      aria-required="true"
                      aria-invalid="false"
                      onChange={(e) => {
                        const { name, value } = e.target;
                        this.setState({
                          variationId: value,
                        });
                      }}
                      value={this.state.variationId}
                    >
                      <option value="">None</option>

                      {this.state.product &&
                        this.state.product.displayedVariations.map(
                          (variation) => (
                            <option value={variation.id}>
                              {variation.combination.map(
                                (comb) => `${comb.name},`
                              )}
                            </option>
                          )
                        )}
                    </select>
                  </div>
                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Sub Category
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="subCategory"
                      value={this.state.subCategory}
                      onChange={this.handleChange}
                      id="exampleFormControlInput1"
                      placeholder="write short note"
                      style={{
                        borderColor: "gainsboro",
                        borderRadius: 5,
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Note
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="note"
                      value={this.state.note}
                      onChange={this.handleChange}
                      id="exampleFormControlInput1"
                      placeholder="Enter description here"
                      style={{
                        borderColor: "gainsboro",
                        borderRadius: 5,
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Total Bill
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="totalBill"
                      value={this.state.totalBill}
                      onChange={this.handleChange}
                      id="exampleFormControlInput1"
                      placeholder="write total bill"
                      style={{
                        borderColor: "gainsboro",
                        borderRadius: 5,
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Per Unit Price
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="perUnitPrice"
                      value={this.state.perUnitPrice}
                      onChange={this.handleChange}
                      id="exampleFormControlInput1"
                      placeholder="per unit price"
                      style={{
                        borderColor: "gainsboro",
                        borderRadius: 5,
                      }}
                    />
                  </div>

                  <div className="form-group">
                    <label
                      style={{
                        fontWeight: "bold",
                        color: "#505050",
                        marginBottom: 5,
                      }}
                    >
                      Sold/Reduce Qunaity
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      name="quantity"
                      value={this.state.quantity}
                      onChange={this.handleChange}
                      id="exampleFormControlInput1"
                      placeholder="Enter quantity"
                      style={{
                        borderColor: "gainsboro",
                        borderRadius: 5,
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn "
                  data-dismiss="modal"
                  style={{
                    backgroundColor: "darkorange",
                    color: "white",
                    padding: 8,
                    borderRadius: 5,
                    fontWeight: "lighter",
                  }}
                  onClick={() => {
                    this.handleSubmit();
                  }}
                >
                  Reduce stock
                </button>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    transactions: state.products.transactions,
    currentAdmin: state.admins.currentAdmin,
  };
};

export default connect(mapStateToProps, {
  getAllTransactionRedux,
  getAllTransactionsAllTimeRedux,
  uploadTransactionRedux,
  updateSingleProductRedux,
  adjustProductStockRedux,
})(SellsReport);
